import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const MARK = "/api/htt/assets/mark.svg";
export const SWAN = "/api/htt/assets/swan-platinum.svg";
export const LOGO = "/brand/oxytocin-logo.png";

export default function SiteNav({ variant = "light" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dark = variant === "dark";

  return (
    <header
      className={`no-print fixed top-0 inset-x-0 z-40 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-wash/80 border-b border-line shadow-[0_8px_30px_rgba(34,20,82,0.06)]"
          : dark
          ? "bg-transparent border-b border-transparent"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="w-10 h-10 rounded-xl bg-cream ring-1 ring-gold/50 flex items-center justify-center overflow-hidden shadow-sm group-hover:ring-gold transition-[box-shadow] duration-300">
            <img src={LOGO} alt="Oxytocin-Learning Ltd" className="w-8 h-8 object-contain" />
          </span>
          <span
            className={`text-[11px] uppercase tracking-[0.22em] font-bold transition-colors ${
              scrolled || !dark ? "text-purple" : "text-gold-pale"
            }`}
          >
            Oxytocin-Learning Ltd
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <Link
                to="/dashboard"
                className={`hidden sm:inline text-sm font-medium ${scrolled || !dark ? "text-lav hover:text-purple" : "text-white/80 hover:text-white"}`}
                data-testid="nav-dashboard"
              >
                My course
              </Link>
              <button
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className={`text-sm font-semibold rounded-full px-4 py-2 transition-colors ${
                  scrolled || !dark ? "text-purple hover:bg-line/60" : "text-white hover:bg-white/10"
                }`}
                data-testid="nav-signout"
              >
                Sign out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className={`text-sm font-medium px-3 py-2 ${scrolled || !dark ? "text-lav hover:text-purple" : "text-white/85 hover:text-white"}`}
                data-testid="nav-login"
              >
                Sign in
              </Link>
              <Link
                to="/join"
                className="text-sm font-semibold rounded-full px-5 py-2.5 bg-gold text-purple-deep hover:bg-gold-pale transition-colors"
                data-testid="nav-join"
              >
                Enrol
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
